/**
 * api接口的统一出口
 */
import BASE from "./base"; // 导入接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
const sign = {
  // 图形验证码
  getValidCode(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/getValidCode`, params);
  },
  // 短信验证码
  getCardValid(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/sendMessage`, params);
  },
  // 登录
  getLogin(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/login`, params);
  },
  // 注册
  getRegist(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/regist`, params);
  },
    // 忘记密码 
    //验证通过后进行修改密码
  forgetPassword(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/change/forget/password`, params);
  },
    //忘记密码的发送手机号验证码
  forgetMessage(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/send/forget/message`, params);
  },
      //验证忘记密码的手机验证码
  validForgetPassword(params) {
    return axios.post(`${BASE.ZCT_API}/rural/login/valid/forget/password`, params);
  },
};

export default sign;
